export default "__VITE_ASSET__BHkGKXgM__"